module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-withpadding"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Notícias")]), (_vm.reference) ? _c('small', {
    staticClass: "more"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Noticias'
      }
    }
  }, [_vm._v("Ver tudo")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(!_vm.naoTemNoticias) ? _c('noticias-lista', {
    attrs: {
      "noticias": _vm.noticias
    }
  }) : _vm._e()], 1), (_vm.perPage < _vm.totalNoticias && !_vm.reference) ? _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('br'), _c('hr', {
    staticClass: "-normal"
  }), (_vm.pagination) ? _c('paginacao', {
    attrs: {
      "gender": "a",
      "object": "notícias",
      "total": _vm.totalNoticias,
      "totalPage": _vm.totalPages,
      "perPage": _vm.perPage,
      "perPageAtual": _vm.noticias.length,
      "pageAtual": _vm.page
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.naoTemNoticias) ? _c('template', {
    slot: "feedback"
  }, [_c('mensagem', {
    staticClass: "-warn"
  }, [_c('p', [_vm._v("Nenhuma notícia foi encontrada no momento")])])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da596d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Noticias.vue
// module id = 488
// module chunks = 0